import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import AppBody from "../../components/AppBody";
import {
  assingTrainerToTraining,
  showTakeCallDetails
} from "../../../actions/trainer/assign_trainer_action";

const ViewTakeCallTrainers = () => {
  const dispatch = useDispatch("");
  const state = useSelector((state) => state.assignTrainerReducer);
  const navigate = useNavigate();
  const { id } = useParams();
  const [selectedTrainers, setSelectedTrainers] = useState([]);

  useEffect(() => {
    dispatch(showTakeCallDetails({ id: atob(id) }));
  }, []);

  const addTrainerInList = (id) => {
    if (!selectedTrainers.includes(id)) {
      setSelectedTrainers([...selectedTrainers, id]);
    } else {
      setSelectedTrainers(selectedTrainers.filter((item) => item !== id));
    }
  };

  const assingTrainerToTrainer = () => {
    dispatch(
      assingTrainerToTraining({
        trainer_ids: selectedTrainers,
        take_call_id: atob(id)
      })
    );
  };
  if (state.is_done) {
    navigate("/take-calls");
  }

  return (
    <AppBody
      loading={state.loading}
      content={
        <div className="middle-sidebar-left">
          <div className="card w-100 border-0 shadow-xs p-0 mb-4">
            <div className="card-header p-3 w-100 border-0 d-flex rounded-lg">
              <Link to={"/completed-trainings"} className="d-inline-block mt-2">
                <i className="ti-arrow-left font-sm text-white"></i>
              </Link>
              <h4 className="font-xs text-white fw-600 ml-4 mb-0 mt-2">
                View Take Call Trainers
              </h4>
            </div>
            <div className="card-body p-4 w-100 border-0 ">
              {selectedTrainers.length > 0 && (
                <button
                  className="btn-common take-call-btn"
                  type="button"
                  onClick={() => assingTrainerToTrainer()}
                >
                  Assign Trainers{" "}
                </button>
              )}
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Sr.No</th>
                      <th>Select Trainer</th>
                      <th>Traniner</th>
                      <th>Propose Date 1</th>
                      <th>Propose Date 2</th>
                      <th>Propose Date 3</th>
                      <th>Available Status</th>
                      <th>Remark</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {state.list &&
                      state.list.map((li, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>
                            <input
                              type="checkbox"
                              className="form-control assign-check"
                              value={li.trainer_id}
                              checked={
                                selectedTrainers.includes(li.trainer_id) || li.is_assing === 1
                                  ? true
                                  : false
                              }
                              onChange={(e) => addTrainerInList(li.trainer_id)}
                            />
                          </td>
                          <td>{li.first_name + " " + li.last_name}</td>
                          <td>{li.propose_date1}</td>
                          <td>{li.propose_date2}</td>
                          <td>{li.propose_date3}</td>
                          <td>
                            {li.status === 1
                              ? "Availble"
                              : li.status === 2
                                ? "Reschedule"
                                : "Schedule"}
                          </td>
                          <td>{li.remark}</td>{" "}
                          <td>
                            <a
                              className="btn approve_btn btn-common"
                              title="Show Requirements"
                              target="_blank"
                              onClick={() =>
                                navigate(
                                  `/trainer/requirement/confirm/${btoa(li.trainer_id)}/${id}`
                                )
                              }
                            >
                              <i className="fa fa-asterisk"></i>
                            </a>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default ViewTakeCallTrainers;
